import { BaseResponseAttributes } from "../attributes/base-attributes";
import { RestApiResponse } from "./RestApi";
import BaseService from "./BaseService";
import { ExchangeRateAttributes } from "../attributes/exchange-rate-attributes";

export class BaseExchangeRateService extends BaseService {
    static async getAll(page?: number): Promise<
      RestApiResponse<BaseResponseAttributes>
    > {
      return BaseExchangeRateService.getApiClient().get(`admin/base-exchange-rates?page=${page}`,
      {
        params: { page: page },
      });
    }

    static async addExchangeRate(
      data: ExchangeRateAttributes
    ): Promise<RestApiResponse<BaseResponseAttributes>> {
      const url: string = "admin/base-exchange-rates/add";
  
      const formData = new FormData();
      
      // Add text data
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });
      
      return BaseExchangeRateService.getApiClient().sendFormData({
        method: "post",
        url: url,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
    }

    static async updateExchangeRate(
      exchangeRateId: number,
      data: ExchangeRateAttributes,
    ): Promise<RestApiResponse<BaseResponseAttributes>> {
      const url: string = `admin/base-exchange-rates/${exchangeRateId}/update`;

      const formData = new FormData();

      // Add text data
    Object.keys(data).forEach((key) => {
      if(key === 'origin_currency' && data[key]!==null){
        formData.append('origin_currency_id', data[key].id.toString());
      }else{
        if(key === 'destination_currency' && data[key]!==null){
          formData.append('destination_currency_id', data[key].id.toString());
        }else {
          formData.append(key, data[key]);
        }
      }
    });

      return BaseExchangeRateService.getApiClient().sendFormData({
        method: "post",
        url: url,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
    }

    static async searchExchangeRate(
      data: ExchangeRateAttributes, page?: number,
    ): Promise<RestApiResponse<BaseResponseAttributes>> {
      const url: string = `admin/base-exchange-rates/search?page=${page}`;
  
      const formData = new FormData();
  
       // Add text data
    Object.keys(data).forEach((key) => {
      if(key === 'origin_currency' && data[key]!==null){
        formData.append('origin_currency_id', data[key].id.toString());
      }else{
        if(key === 'destination_currency' && data[key]!==null){
          formData.append('destination_currency_id', data[key].id.toString());
        }else {
          formData.append(key, data[key]);
        }
      }
    });
  
      return BaseExchangeRateService.getApiClient().sendFormData({
        method: "post",
        url: url,
        data: formData,
        params: { page: page },
        headers: { "Content-Type": "multipart/form-data" },
      });
    }
}